exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NavigationInfo-17ae32d9{padding:20px 0px}.container-6f765851{padding-top:15px;display:flex;justify-content:space-between}.navItemName-753ab6ef{font-weight:500;line-height:20px;max-width:295px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.navItemName-753ab6ef a,.navItemName-753ab6ef a:visited{color:inherit;text-decoration:none}.navItemName-753ab6ef a:hover{color:#FA6400}.navItemMetrics-802c39b3{margin-top:3px;color:#757575;font-size:13px;line-height:20px}.navItemMetrics-802c39b3 span{display:inline-block;margin-right:10px}\n", ""]);

// Exports
exports.locals = {
	"NavigationInfo": "NavigationInfo-17ae32d9",
	"container": "container-6f765851",
	"navItemName": "navItemName-753ab6ef",
	"navItemMetrics": "navItemMetrics-802c39b3"
};